// extracted by mini-css-extract-plugin
export var brandLockup = "_ms-5";
export var brandLogo = "_ms-6";
export var bullet = "_ms-1i";
export var bulletText = "_ms-1h";
export var bullets = "_ms-1c";
export var callout = "_ms-12";
export var calloutBody = "_ms-14";
export var calloutLabel = "_ms-13";
export var checkIcon = "_ms-1e";
export var checkList = "_ms-1b";
export var checkSvg = "_ms-1f";
export var checkText = "_ms-1g";
export var choiceCard = "_ms-x";
export var choiceDescription = "_ms-10";
export var choiceIcon = "_ms-11";
export var choiceText = "_ms-y";
export var choiceTitle = "_ms-z";
export var closeButton = "_ms-d";
export var codeText = "_ms-28";
export var compactPage = "_ms-f";
export var content = "_ms-9";
export var contentColumn = "_ms-3";
export var coverageCard = "_ms-o";
export var coverageDescription = "_ms-24";
export var coverageTitle = "_ms-23";
export var eyebrow = "_ms-i";
export var fieldCard = "_ms-m";
export var fieldDescription = "_ms-r";
export var fieldError = "_ms-s";
export var fieldHeader = "_ms-p";
export var fieldTitle = "_ms-q";
export var finalNote = "_ms-29";
export var footer = "_ms-a";
export var fulfillmentBody = "_ms-1u";
export var fulfillmentBodyText = "_ms-1v";
export var fulfillmentRow = "_ms-1r";
export var fulfillmentRows = "_ms-1q";
export var fulfillmentTitle = "_ms-1t";
export var header = "_ms-4";
export var heading = "_ms-h";
export var helperText = "_ms-1k";
export var indented = "_ms-1x";
export var inlineLink = "_ms-26";
export var inlineTitle = "_ms-2a";
export var intro = "_ms-k";
export var linkPreview = "_ms-1z";
export var listItem = "_ms-1d";
export var main = "_ms-1";
export var marketingImage = "_ms-c";
export var marketingPanel = "_ms-b";
export var modal = "_ms-0";
export var noteBody = "_ms-v";
export var noteBodyText = "_ms-w";
export var noteCard = "_ms-n";
export var noteIcon = "_ms-t";
export var noteTitle = "_ms-u";
export var numberBadge = "_ms-2e";
export var numberedStep = "_ms-2c";
export var numberedStepBody = "_ms-2f";
export var numberedStepCta = "_ms-2d";
export var numberedStepDescription = "_ms-2h";
export var numberedStepTitle = "_ms-2g";
export var numberedSteps = "_ms-2b";
export var page = "_ms-e";
export var playCircle = "_ms-18";
export var playIcon = "_ms-19";
export var policyBody = "_ms-21";
export var policyHeader = "_ms-20";
export var policyPreview = "_ms-1y";
export var policyTitle = "_ms-22";
export var progressFill = "_ms-8";
export var progressTrack = "_ms-7";
export var pseudoLink = "_ms-25";
export var pseudoLinkIcon = "_ms-27";
export var rowHeader = "_ms-1s";
export var section = "_ms-g";
export var shell = "_ms-2";
export var statusIconSuccess = "_ms-1m";
export var statusIconSvg = "_ms-1o";
export var statusIconWarning = "_ms-1n";
export var statusRow = "_ms-1l";
export var statusText = "_ms-1p";
export var stepTitle = "_ms-j";
export var strongText = "_ms-1w";
export var subHeading = "_ms-l";
export var videoEmbed = "_ms-16";
export var videoIframe = "_ms-17";
export var videoLabel = "_ms-1a";
export var videoPlaceholder = "_ms-15";
export var warningIcon = "_ms-1j";